import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import projects from '../project-v2/projectsReducer';
import offer from '../offer/offerReducer';
import confirmation from '../confirmation/confirmationReducer';
import authenticate from '../authenticate/authenticateReducer';
import error from './errorReducer';

import user from '../reducers/user';

import roles from '../reducers/roles';
import rights from '../reducers/rights';
import lockings from '../reducers/lockings';
import project from '../reducers/project';

const entities = combineReducers({
	roles,
	rights,
	lockings,
	project
});

import app from '../reducers/app';

const rootReducer = combineReducers({
	user,
	projects,
	offer,
	confirmation,
	authenticate,
	routing: routerReducer,
	error,
	entities,
	app
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/js/app/rootReducer.js